<template>
    <div class="row position-relative" style="margin-top: 55px;">
        <div class="bg-computer">
            <div class="row container my-5 py-3">
                <div class="col-2"></div>
                <div class="col-md-5 text-end pe-5">
                    <h3 class="fw-bold my-4">راهکارهای نوین برای تولیدکنندگان</h3>
                    <button class="btn-blue mt-5">ثبت نام رایگان</button>
                </div>
                <div class="col-md-5 text-start">
                    <img src="../../assets/services-img/computer.png" width="85%" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row col-lg-9 mx-auto px-0">
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <h3 class="fw-bold">راهکارهای ما برای صاحبان کسب‌وکارها</h3>
                    <h5 class="mt-3 ps-3" style="line-height: 30px;">
                        در دنیای رقابتی امروز، تولیدکنندگان برای افزایش بهره‌وری، کاهش هزینه‌ها و بهینه‌سازی فرآیندهای تولیدی نیازمند استفاده از فناوری‌های نوین هستند. ما در شرکت خود، با بهره‌گیری از هوش مصنوعی، اینترنت اشیا، بلاکچین و تحلیل داده، راهکارهای پیشرفته‌ای را برای تولیدکنندگان ارائه می‌دهیم. خدمات ما به شما کمک می‌کند تا فرآیندهای تولیدی را بهینه کرده، کیفیت محصولات را افزایش دهید و مزیت رقابتی پایدار ایجاد کنید.
                    </h5>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="text-end">
                        <h4 class="fw-bold">چالش‌های تولیدکنندگان</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>
                                    <strong>افزایش هزینه‌های تولید:</strong>هزینه‌های مواد اولیه، انرژی و نیروی انسانی در حال افزایش است.
                                </li>
                                <li class="mt-3">
                                    <strong>نیاز به بهینه‌سازی فرآیندهای تولیدی:</strong>تولیدکنندگان نیازمند کاهش اتلاف منابع و بهبود عملکرد خطوط تولید هستند.</li>
                                <li class="mt-3">
                                    <strong>مدیریت داده‌های تولید و عملکرد ماشین‌آلات:</strong>بسیاری از واحدهای تولیدی قادر به جمع‌آوری و تحلیل دقیق داده‌های تولید نیستند.</li>
                                <li class="mt-3">
                                    <strong>کیفیت و استانداردهای تولید:</strong> رعایت استانداردهای کیفیت برای حفظ رقابت‌پذیری ضروری است.</li>
                                <li class="mt-3">
                                    <strong>مدیریت زنجیره تأمین و تأمین‌کنندگان:</strong>تولیدکنندگان با چالش‌هایی در مدیریت تأمین مواد اولیه و تعامل با تأمین‌کنندگان روبه‌رو هستند.
                                </li>
                            </ul>
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <h3 class="fw-bold">خدمات ما برای تولیدکنندگان</h3>
                <h6>ما راهکارهای جامع و نوآورانه‌ای را برای تولیدکنندگان ارائه می‌دهیم که شامل موارد زیر است:</h6>
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5">بهینه‌سازی فرآیندهای تولید با هوش مصنوعی</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>تحلیل داده‌های تولیدی برای افزایش بهره‌وری خطوط تولید</li>
                                <li>پیاده‌سازی مدل‌های یادگیری ماشین برای پیش‌بینی خرابی تجهیزات و کاهش توقفات</li>
                                <li>بهینه‌سازی مصرف انرژی در فرآیندهای تولیدی</li>
                            </ul>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img17.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/img18.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">اینترنت اشیا (IoT) برای هوشمندسازی کارخانه‌ها</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>اتصال ماشین‌آلات و تجهیزات تولیدی برای نظارت و کنترل دقیق‌تر</li>
                                <li>جمع‌آوری و تحلیل داده‌های عملکردی برای بهبود فرآیندهای تولید</li>
                                <li>مانیتورینگ هوشمند خطوط تولید برای کاهش ضایعات و افزایش بهره‌وری</li>
                            </ul>    
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/img18.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5">  راهکارهای بلاکچین برای شفافیت و امنیت در زنجیره تأمین</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>ردیابی تأمین مواد اولیه از منابع مختلف برای تضمین کیفیت</li>
                                <li>ایجاد سیستم‌های قرارداد هوشمند برای مدیریت تأمین‌کنندگان</li>
                                <li>کاهش تقلب و افزایش شفافیت در فرآیندهای تأمین و تولید</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img19.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/img20.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">مدیریت و تحلیل داده‌های تولیدی</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>تجزیه و تحلیل داده‌های عملکردی برای افزایش راندمان تولید</li>
                                <li>پیاده‌سازی داشبوردهای مدیریتی برای مانیتورینگ لحظه‌ای تولید</li>
                                <li>استفاده از داده‌های تولید برای بهینه‌سازی و تصمیم‌گیری بهتر</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/img20.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5"> بهینه‌سازی کیفیت و کاهش ضایعات تولید</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>استفاده از هوش مصنوعی برای پیش‌بینی نقص‌های احتمالی در محصولات</li>
                                <li>پیاده‌سازی سیستم‌های کنترل کیفیت خودکار در خطوط تولید</li>
                                <li>تحلیل داده‌های تولید برای کاهش ضایعات و افزایش استانداردهای کیفی</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/production.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/Logistics.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5"> سیستم‌های مدیریت زنجیره تأمین و لجستیک</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>بهینه‌سازی فرآیندهای تأمین و انبارداری برای کاهش هزینه‌ها</li>
                                <li>پیاده‌سازی سیستم‌های هوشمند برای مدیریت سفارشات و توزیع</li>
                                <li>بهبود ارتباطات بین تولیدکنندگان و تأمین‌کنندگان با راهکارهای دیجیتال</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/Logistics.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5"> دیجیتال‌سازی و تحول صنعتی</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>اجرای پروژه‌های Industry 4.0 برای هوشمندسازی تولید</li>
                                <li>پیاده‌سازی نرم‌افزارهای یکپارچه مدیریت تولید (MES) و مدیریت منابع سازمانی (ERP)</li>
                                <li>آموزش تیم‌های تولیدی برای استفاده بهینه از فناوری‌های نوین</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/digital.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row position-relative">
        <div class="bg-computer" style="border-top-right-radius: 40px; padding-left: 200px;">
            <div class="container my-5 py-3">
                <h3 class="my-5 text-end">نتایج و ارزش‌آفرینی برای تولیدکنندگان</h3>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/img14.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>کاهش هزینه‌های تولید و افزایش بهره‌وری</strong> از طریق بهینه‌سازی فرآیندهای تولیدی
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/production.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>بهبود کیفیت محصولات و کاهش ضایعات</strong> با استفاده از داده‌محوری و یادگیری ماشین 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-lg-flex d-none">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش شفافیت و امنیت در زنجیره تأمین</strong> از طریق راهکارهای بلاکچین 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-lg-none d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش شفافیت و امنیت در زنجیره تأمین</strong> از طریق راهکارهای بلاکچین 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/img2.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>مدیریت هوشمند منابع و تجهیزات </strong> با بهره‌گیری از اینترنت اشیا 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/fast.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش سرعت در تصمیم‌گیری‌های مدیریتی </strong> با استفاده از داشبوردهای داده‌محور 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Business.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>بهینه‌سازی مصرف انرژی و کاهش هزینه‌های زیست‌محیطی</strong> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="container py-3">
        <div class="row col-md-9 mx-auto mt-5">
            <h3>سوالات متداول</h3>
            <div class="mx-auto my-5">
              <div class="accordion accordion-flush" id="accordionExample">
                <!-- 1: coll1 -->
                <div class="accordion-item">
                  <h2 class="accordion-header text-end">
                    <!--   data-bs-target="#coll1",  controls="coll1", id="coll1", aria-expanded="true"      -->
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#coll1" aria-expanded="true" aria-controls="coll1">
                      <h6>چگونه می‌توانم از خدمات شما برای بهینه‌سازی تولید استفاده کنم؟</h6>
                    </button>
                  </h2>
                  <!-- show : by default Always open -->
                  <div id="coll1" class="accordion-collapse collapse show text-end" data-bs-parent="#accordionExample">
                    <div class="accordion-body text-end" style="line-height: 35px !important;">
                        شما می‌توانید با تیم مشاوره ما تماس بگیرید تا پس از بررسی نیازهای شما، بهترین راهکارهای فناوری برای افزایش بهره‌وری و کاهش هزینه‌ها ارائه شود.
                    </div>
                  </div>
                </div>

                <!-- 2: coll2 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--       collapsed,   aria-expanded="false"   -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll2" aria-expanded="false" aria-controls="coll2">
                      <h6>آیا این خدمات برای همه انواع تولیدکنندگان مناسب است؟</h6>
                    </button>
                  </h2>
                  <div id="coll2" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بله، ما خدمات خود را برای صنایع مختلف تولیدی از جمله خودروسازی، صنایع غذایی، تولید قطعات صنعتی و غیره سفارشی‌سازی می‌کنیم.
                    </div>
                  </div>
                </div>

                <!-- 3: coll3 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll3" aria-expanded="false" aria-controls="coll3">
                      <h6> چگونه می‌توانم کیفیت محصولات تولیدی خود را بهبود دهم؟</h6>
                    </button>
                  </h2>
                  <div id="coll3" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        ما با استفاده از هوش مصنوعی، اینترنت اشیا و تحلیل داده‌ها، راهکارهایی برای پیش‌بینی نقص‌ها، کنترل کیفیت و کاهش ضایعات ارائه می‌دهیم.
                    </div>
                  </div>
                </div>

                <!-- 4: coll4 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll4",  id="coll4"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll4" aria-expanded="false" aria-controls="coll4">
                      <h6>آیا سیستم‌های شما با نرم‌افزارهای مدیریت تولید موجود قابل یکپارچه‌سازی هستند؟</h6>
                    </button>
                  </h2>
                  <div id="coll4" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بله، ما راهکارهای خود را به‌گونه‌ای طراحی می‌کنیم که با سیستم‌های ERP، MES و دیگر نرم‌افزارهای صنعتی شما یکپارچه شوند.
                    </div>
                  </div>
                </div>

                <!-- 5: coll5 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll5",  id="coll5"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll5" aria-expanded="false" aria-controls="coll5">
                      <h6> آیا برای پیاده‌سازی این فناوری‌ها، آموزش کارکنان نیز ارائه می‌شود؟</h6>
                    </button>
                  </h2>
                  <div id="coll5" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بله، ما علاوه بر پیاده‌سازی فناوری‌ها، آموزش‌های لازم را نیز به تیم‌های تولیدی ارائه می‌دهیم تا بتوانند از ابزارهای جدید به بهترین شکل استفاده کنند.
                        <br>
                        ما در کنار تولیدکنندگان هستیم تا با ارائه راهکارهای نوآورانه و فناوری‌های پیشرفته، صنعت تولید را متحول کنیم. جهت دریافت مشاوره و اطلاعات بیشتر، با ما در تماس باشید.
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style lang="scss" scoped>
.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-button:not(.collapsed) {
  /* background-color: #c5e5d8;*/
  background-color: #f7f7f7;
}

.accordion-button:not(.collapsed)::after {
  background-image: none;
  transform: none;
}

.accordion-button:focus {
  box-shadow: none;
  z-index: 1;
}

.accordion-button:before {
  content: "";
  position: absolute;
  /*   right: 0.75rem; */
  left: 0.75rem;
  top: 1.25rem;
  height: 2px;
  width: 1rem;
  background-color: #1838D2;
}
.accordion-button.collapsed:after {
  content: "";
  position: absolute;
  /*   right: 1.1875rem; */
  left: 1.1875rem;
  top: 0.8125rem;
  height: 1.0625rem;
  width: 0.125rem;
  border-style: none;
  background-color: #1838D2;
}

.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-body {
  background-color: #f7f7f7;
  font-size: 14px !important;
  padding-left: 50px;
  padding-right: 30px;
  text-align: justify;
}
</style>